import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
} from "@material-tailwind/react";

import { usePaymentsContext } from "../contexts/PaymentsContextProvider";

/**
 * CustomDialog component
 * @param {boolean} open - Controls dialog visibility
 * @param {function} onClose - Function to call on dialog close
 * @param {function} onConfirm - Function to call on OK/Confirm button click
 * @param {string} coinsFeature - App Feature
 **/

const CustomDialogForCoinsDeduct = ({
  open,
  onClose,
  onConfirm,
  coinsFeature,
}) => {
  const { getFeatureCoinsDetails } = usePaymentsContext();
  const [featureCoinsDetails, setFeatureCoinsDetails] = useState({});

  useEffect(() => {
    const featureCoins = async () => {
      const result = await getFeatureCoinsDetails();
      const featurePricingDetails = result?.result?.find(
        (x) => x.app_feature === coinsFeature
      );
      setFeatureCoinsDetails(featurePricingDetails);
    };
    featureCoins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog open={open} handler={onClose} className="rounded-xl">
      <DialogHeader className="text-xl font-semibold">
        Coins deduction for this operation
      </DialogHeader>
      <DialogBody className="text-base text-gray-700">
        <span className="mr-2">For this operation</span>
        <span className="font-bold text-lg text-wabmBlue">
          {featureCoinsDetails?.feature_price}
        </span>
        <span className="ml-2">
          coins will be deducted. Do you want to proceed?
        </span>
      </DialogBody>
      <DialogFooter>
        <Button variant="text" color="red" onClick={onClose} className="mr-2">
          Cancel
        </Button>
        <Button variant="gradient" color="green" onClick={onConfirm}>
          Yes
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default CustomDialogForCoinsDeduct;
